module.exports = __webpack_public_path__ + "static/r31-4f48833de58a2440f87ce2fffa7da75b.jpg";